<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Exportación de conteo</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs4>
                <v-autocomplete
                        v-model="form.ea"
                        :items="eventos"
                        :loading="loading"
                        clearable
                        hide-details
                        hide-selected
                        return-object
                        item-text="desig"
                        item-value="id"
                        label="Seleccione evento"
                >
                    <template slot="item" slot-scope="{ item, tile }">
                        <v-list-tile-content>
                            <v-list-tile-title v-text="item.desig"></v-list-tile-title>
                            <v-list-tile-sub-title>Fechas: {{ item.desde }} a {{ item.hasta }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                </v-autocomplete>
            </v-flex>
            <transition name="custom" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <v-flex v-if="form.ea.id">
                    <h2>Evento</h2>
                    <h3 class="display-2">{{ form.ea.desig }}</h3>
                    <h3 class="display-1">{{ form.ea.desde }} a {{ form.ea.hasta }}</h3>
                    <v-divider></v-divider>
                    <v-radio-group v-model="form.exporta">
                        <v-radio label="Generar Archivo" value="a"></v-radio>
                        <v-radio label="Enviar a Microsiga" value="m"></v-radio>
                    </v-radio-group>
                    <v-switch label="¿Realizar exportación aunque posea errores?" v-model="form.err"></v-switch>
                    <v-btn :loading="loading" color="primary" @click.native="procesar">generar</v-btn>
                    <v-btn v-if="mostrarDescarga" :href="descarga" tag="a">descargar</v-btn>
                    <br>
                    <v-progress-linear :indeterminate="indeterminado" v-model="progreso.porcent" :active="loading" height="5"></v-progress-linear>
                </v-flex>
            </transition>
            <v-dialog v-model="modalErrores" persistent max-width="900" scrollable>
                <v-card>
                    <v-card-title class="headline grey lighten-2">Error de Validación</v-card-title>
                    <v-card-text>
                        <v-list three-line>
                            <template v-for="(v,k) in errores">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title><b>Motivo:</b> {{ v[3]}}</v-list-tile-title>
                                        <v-list-tile-sub-title>Producto: {{ v[0] }} | Lote: {{ v[2] }} | Depósito: {{ v[1] }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click.native="modalErrores = false">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>

</template>
<script>
    import {mapActions} from 'vuex';
    import saveAs from 'file-saver';

    export default {
        data() {
            return {
                eventos: [],
                loading: false,
                form: {
                    err: false,
                    exporta: 'a',
                    ea: {}
                },
                descarga: '',
                mostrarDescarga: false,
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: ''
                },
                modalErrores: false,
                errores: [],
                indeterminado: true,
                progreso: {
                    porcent: 0,
                    msj: ''
                },
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.loading = true;
                this.$http.post('stock/evento/list')
                    .then(r => {
                        this.eventos = r.data;
                        this.loading = false;
                    }, err => {
                        alert(err)
                        this.loading = false;
                    })
            },
            procesar() {
                if (!this.form.ea.id) {
                    this.msjShow({txt: 'Debe seleccionar un evento', tipo: 'error'});
                    return false
                }
                this.mostrarDescarga = false;
                this.loading = true;

                this.$http({
                    method: 'post',
                    url: 'stock/evento/procesar',
                    headers: {'Content-Type': 'application/json', 'Accept': 'text/csv'},
                    responseType: "blob",
                    data: this.form
                })
                    .then((response) => {
                        let disposition = response.headers['content-disposition']
                        let filename = 'evento_export.csv'
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }
                        saveAs(response.data,filename);
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.msjShow({txt: 'Error al procesar evento', tipo: 'error'});
                    });
            }
        }
    }
</script>
<style>
    .list-wrap {
        max-height: 300px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/stock/export.vue